import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import * as d3 from 'd3'
export const isMobile: boolean = browserCheck.isMobile
export const maxDays = 150
export const xScaleSteps = 50

// SVG-PATH-STRING FÜR SCHLOSS-ICON
export const icon =
  'M4.7-1.6H3.9v-1.1c0-2.1-1.7-3.7-3.9-3.7s-3.9,1.7-3.9,3.7v1.1h-0.8C-4.9-1.6-5-1.5-5-1.3v6.7 c0,0.6,0.5,1.1,1.1,1.1h7.8C4.5,6.4,5,5.9,5,5.4v-6.7C5-1.5,4.9-1.6,4.7-1.6z M1.4-1.6h-2.8v-0.7C-1.4-3-0.8-3.6,0-3.6 S1.4-3,1.4-2.3V-1.6z'
// LÄNDER FÜR ACHSENVERGLEICH
export const countriesForBigChart = ['CH', 'IT', 'ES', 'KP', 'US', 'GB', 'SE']
// MASSNAHMEN DER AUSGEWÄHLTEN LÄNDER
export const measures = {
  CH: {
    date: '16.3.2020',
    text: (
      <>
        <b>11 Tage</b> nachdem 100 Fälle überschritten wurden – Am 16. März rief
        der Bundesrat eine «ausserordentliche Lage» für die <b>Schweiz</b> aus.
        Sämtliche Geschäfte und Lokale müssen schliessen, Grenzen werden
        kontrolliert.
      </>
    ),
    code: 'CH'
  },
  IT: {
    date: '11.3.2020',
    text: (
      <>
        <b>17 Tage</b> nachdem 100 Fälle überschritten wurden – Am 11. März
        riegelte <b>Italien</b> das ganze Land ab inklusive Ausgangssperre und
        Grenzschliessungen.
      </>
    ),
    code: 'IT'
  },
  // CN: {
  //   date: '24.1.2020',
  //   text: (
  //     <>
  //       <b>5 Tage</b> nachdem 100 Fälle überschritten wurden – Am 24. Januar
  //       riegelte <b>China</b> insgesamt 15 Städte mit insgesamt 60 Millionen
  //       Menschen in der Region Hubei ab. Ähnliche Beschränkungen gab es im
  //       ganzen Land.
  //     </>
  //   ),
  //   code: 'CN'
  // },
  ES: {
    date: '13.3.2020',
    text: (
      <>
        <b>11 Tage</b> nachdem 100 Fälle überschritten wurden – In{' '}
        <b>Spanien</b> gilt seit dem 13. März eine Ausgangssperre. Zur
        Überwachung setzt die spanische Polizei auch Drohnen ein. Die Menschen
        dürfen nur noch aus dem Haus, um Lebensmittel einzukaufen oder zur
        Apotheke, zum Arzt und zur Arbeit zu gehen.
      </>
    ),
    code: 'ES'
  },
  GB: {
    date: '23.3.2020',
    text: (
      <>
        <b>18 Tage</b> nachdem 100 Fälle überschritten wurden – In{' '}
        <b>Grossbritannien</b> ist seit dem 23. März eine Ausgangssperre in
        Kraft. Das eigene Haus darf nur noch zum Einkaufen oder zum Gang zur
        Arbeit verlassen werden. Versammlungen von mehr als zwei Personen im
        öffentlichen Raum sind verboten. Zuvor hatte London nur sehr zögerlich
        auf die Krise reagiert.
      </>
    ),
    code: 'GB'
  },
  KP: {
    date: undefined,
    text: (
      <>
        <br />
        In <b>Südkorea</b> gab es keinen Shutdown, es wird allerdings sehr breit
        getestet, um die Kranken zu isolieren. Zudem gibt es Apps und Websites,
        die vor Orten warnen, an denen sich die Infizierten aufgehalten haben.
      </>
    ),
    code: 'KP'
  },

  US: {
    date: undefined,
    text: (
      <>
        <br />
        Die <b>USA</b> fordern die Bevölkerung auf, Abstand zu zu halten und
        Ansammlungen von mehr als zehn Personen zu vermeiden. Weiter gehen viele
        Bundesstaaten, die ihre Bürger auffordern, zu Hause zu bleiben.
      </>
    ),
    code: 'US'
  },
  SE: {
    date: undefined,
    text: (
      <>
        <br />
        <b>Schweden</b> folgt einem zurückhaltenderen Kurs gegen das Virus. Die
        meisten Massnahmen zur Eindämmung der Epidemie sind freiwillig.
      </>
    ),
    code: 'SE'
  }
}
// ACHSENVERGLEICHSCHARTS
export const totalCasesBigConfig = {
  yScale: d3.scaleLog(),
  yRange: [10, isMobile ? 400 : 570],
  yDomain: [100, 2500000],
  xDomain: [0, maxDays],
  yAxisWidth: 60,
  doublingMarker: [
    { curvePoint: 3, off: { x: isMobile ? 0 : 0, y: isMobile ? 0 : 0 } },
    { curvePoint: 25, off: { x: isMobile ? 0 : 0, y: isMobile ? 0 : 0 } },
    { curvePoint: 8, off: { x: isMobile ? 0 : 0, y: isMobile ? 0 : 0 } }
  ]
}
export const totalCasesBigLinearConfig = {
  yScale: d3.scaleLinear(),
  yRange: [30, isMobile ? 180 : 440],
  yDomain: [0, 2500000],
  xDomain: [0, maxDays],
  yAxisWidth: 50,
  doublingMarker: [
    { curvePoint: 1, off: { x: isMobile ? 0 : 0, y: isMobile ? 0 : 0 } },
    { curvePoint: 1, off: { x: isMobile ? 0 : 0, y: isMobile ? 0 : 0 } },
    { curvePoint: 1, off: { x: isMobile ? -220 : 8, y: isMobile ? 0 : 0 } }
  ]
}
// TEASER-IDs
export const relatedArticles = [
  '594923417757',
  '921118466582',
  '835706479183',
  '147144460867',
  '782139135771',
  '533675517866',
  '172597671179',
  '15650041'
]
// TEXTE
export const textLinear =
  'Auf einer linearen Skala ist die Abfolge der Werte gleichmässig. 1, 2, 3, (...) haben den gleichen Abstand zueinander.'
export const textLogarithmisch =
  'Der Vergleich der Entwicklung der Fallzahlen lässt sich visuell am deutlichsten zeigen, wenn man sie auf einer logarithmischen Achse darstellt. Auf solch einer Skala wird nicht der Zahlenwert einer Grösse abgetragen, sondern der Logarithmus desselben. Die Y-Achse wird gestaucht und ermöglicht so, grössere Wertebereiche übersichtlich und platzsparend darzustellen. Kleine Werte werden gegenüber grossen Werten stärker gewichtet, das heisst, es ist auch bei kleinen Veränderungen schnell Bewegung in der Kurve zu sehen.'

export const doublingKeyText = isMobile
  ? 'Verdopplung nach :'
  : 'Steigung bei einer Verdopplung der Fälle nach:'
export const lockKeyText = isMobile
  ? 'Zeitpunkt von drastischen Massnahmen'
  : 'Zeitpunkt von drastischen Massnahmen'
